import React from 'react'
import { Router, hashHistory } from 'react-router'
import Layout from 'containers/index/Layout'
import mainweb from 'containers/web/Index'

const rootRoute = {
  path: '/',
  childRoutes: [
    require('./user-manage/index').default,
    require('./main-layout/index').default
    // require('./404').default,
    // require('./redirect').default
  ],
  // indexRoute: { onEnter: (nextState, replace) => replace('/m') },
  indexRoute: {component: mainweb},
  component: Layout
}

const routes = (history = hashHistory) => (
  <Router history={history} routes={rootRoute} />
)

export default routes



// WEBPACK FOOTER //
// ./src/routes/index.js